import {
  PagedResponse,
  PatchWithMeta,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { AnyAction } from "redux";
import { ContactTheRegulator } from "../domain/ContactTheRegulator";
import { MODULE_NAME } from "../moduleName";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const LOADED_ITEMS = `${MODULE_NAME}/LOADED_ITEMS`;
export const LOADING_ITEMS = `${MODULE_NAME}/LOADING_ITEMS`;

export const LOADED_ITEM = `${MODULE_NAME}/LOADED_ITEM`;
export const LOADING_ITEM = `${MODULE_NAME}/LOADING_ITEM`;
export const SAVED_ITEM = `${MODULE_NAME}/SAVED_ITEM`;

export const UPDATING_ITEM = `${MODULE_NAME}/UPDATING_ITEM`;
export const UPDATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/UPDATING_ITEM_VALIDATION_FAIL`;

export const INPUTTING_ITEM = `${MODULE_NAME}/INPUTTING_ITEM`;
export const CREATING_ITEM = `${MODULE_NAME}/CREATING_ITEM`;
export const CREATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/CREATING_ITEM_VALIDATION_FAIL`;
export const CREATED_ITEM = `${MODULE_NAME}/CREATED_ITEM`;
export const SENDING_MESSAGE = `${MODULE_NAME}/SENDING_MESSAGE`;
export const CLOSING_ITEM = `${MODULE_NAME}/CLOSING_ITEM`;
export const ASSIGNING_ITEM = `${MODULE_NAME}/ASSIGNING_ITEM`;
export const SEND_MESSAGE_ERROR = `${MODULE_NAME}/SEND_MESSAGE_ERROR`;
export const CLEAR_ERROR = `${MODULE_NAME}/CLEAR_ERROR`;
export const REOPENING_ITEM = `${MODULE_NAME}/REOPENING_ITEM`;

export const loadedItems = (payload: PagedResponse<ContactTheRegulator>) => ({
  type: LOADED_ITEMS,
  payload,
});
export const loadingItems = (payload: QueryParams) => ({
  type: LOADING_ITEMS,
  payload,
});

export const loadedItem = (item: ContactTheRegulator) => ({
  type: LOADED_ITEM,
  payload: item,
});

export const savedItem = (item: ContactTheRegulator) => ({
  type: SAVED_ITEM,
  payload: item,
});

export const loadingItem = (id: string) => ({
  type: LOADING_ITEM,
  payload: id,
});

export const updatingItem = (
  id: string,
  patchWithMeta: PatchWithMeta<ContactTheRegulator>,
  resourceTagsIds: number[]
) => ({
  type: UPDATING_ITEM,
  payload: { id, patchWithMeta, resourceTagsIds },
});

export const createItem = (item: ContactTheRegulator) => ({
  type: CREATING_ITEM,
  payload: item,
});

export const inputtingItem = () => ({
  type: INPUTTING_ITEM,
});

export const sendMessage = (id: string, files: File[], message: string) => ({
  type: SENDING_MESSAGE,
  payload: { id, files, message },
});

export const closeCtr = (id: string) => ({
  type: CLOSING_ITEM,
  payload: { id },
});

export const reOpenCtr = (id: string) => ({
  type: REOPENING_ITEM,
  payload: { id },
});

export const assignItem = (
  id: string,
  assignedToUpn: string,
  assignedToDisplayName: string
) => ({
  type: ASSIGNING_ITEM,
  payload: { id, assignedToUpn, assignedToDisplayName },
});

export const sendMessageError = (message: string) => ({
  type: SEND_MESSAGE_ERROR,
  payload: { message },
});

export const clearError = () => ({ type: CLEAR_ERROR });

